// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__1C1eU","label":"Completed_label__1G1Ez"};